<template>
  <div class="newslist">
    <section class="main">
      <div class="t_pic_box">
        <img class="t_pic" src="../assets/img/newslist/banner2.jpg" alt />
      </div>
      <div class="bread">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>关于粒上皇</el-breadcrumb-item>
          <el-breadcrumb-item>公司新闻</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="nlist">
        <div class="nlist_item flex" v-for="(item,index) in list" :key="index" @click="goDetail(item.id)">
          <div :style="{'background':'url('+pic_url+item.picUrl+') no-repeat center center/cover'}" class="limg" ></div>
          <!-- <img :src="pic_url+item.picUrl" alt /> -->
          <div class="content">
            <h3 class="news_tit">{{item.title}}</h3>
            <h5 class="news_time">{{item.createDate|formatTime_a}}</h5>
            <p class="ellipsis_muti">{{item.introduction}}</p>
          </div>
        </div>
         <!-- <div class="look-more">VIEW MORE</div> -->
        <el-pagination background layout="prev, pager, next,jumper" :total="total" v-show="total>0" @current-change="handleCurrentChange"></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import {newslist} from '../api/index.js'
export default {
  data() {
    return {
      list:[],
      total:0,
      pageNum:1,
      pic_url:process.env.VUE_APP_PIC_API
    };
  },
  created(){
    this.getList();
  },
  filters:{
    formatTime_a(time) {
  var date = new Date(time);
  var year = date.getFullYear()
  var month = date.getMonth() + 1
  var day = date.getDate()
  return year + '-' + month + '-' + day
}
  },
  methods:{
     getList(){
       this.loading=true;
      let param={
        pageNum:this.pageNum,
        pageSize:10,
      }
      newslist(param).then(res=>{
        console.log(res)
        if(res.resultCode=='0'){
          this.list=res.data.list;
          this.total=res.data.total;
        }
        this.loading=false;
      })
    },
    goDetail(id){
      this.$router.push({
        path:'newsdetail',
        query:{id:id}
      })
    },
     handleCurrentChange(val) {
      console.log(val)
      this.pageNum=val;
      this.getList()
      // 当前页 改变
    }
  }
};
</script>

<style lang="scss" scoped>
.newslist {
  .t_pic_box {
    font-size: 0;
  }
  .t_pic {
    width: 100%;
  }
  .nlist {
    width: 1000px;
    margin: 0 auto;
    padding: 52px 0 120px;
    text-align: left;
    .nlist_item {
      margin-bottom: 32px;
      cursor: pointer;
      .limg {
        width: 240px;
        height: 160px;
        margin-right: 24px;
        border-radius: 8px;
      }
      .content {
        flex: 1;
        h3 {
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #151515;
          line-height: 22px;
          padding: 8px 0 10px;
        }
        .news_time {
          font-family: 'HarmonyOS Sans SC';
          font-size: 14px;
          color: #7a7a7a;
          padding-bottom: 12px;
          line-height: 26px;
        }
        p {
          font-family: PingFangSC-Regular;
          font-size: 14px;
          color: #7a7a7a;
          letter-spacing: 0;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.bread,
.el-breadcrumb {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background: #fafafa;
}
.el-breadcrumb {
  width: 1200px;
  margin: 0 auto;
}
</style>